var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { XbpmApiService, XbpmAuthService, XbpmLogger, XbpmAsyncStorage, StorageBrowser, createStore, XbpmContext, formatNavParams, SCREENFLOW_END, NOT_AUTHORIZED, FORM_DESTROYED, version as coreVersion, } from '@unitarius/xbpm-runtime';
import { XbpmBridgeClientService, XbpmBridgeHostService, PubSub, version as bridgeVersion, } from '@unitarius/xbpm-runtime-web-bridge';
import { OAuthProvider, version as oauthVersion } from '@unitarius/xbpm-runtime-web-oauth';
import qs from 'qs';
import { getConfig } from './config';
import { eqUrlParts } from './utils/_.utils';
import { createBrowserHistory } from 'history';
import { injector } from './injector';
import { XbpmWebNavService } from './services/nav.service';
import { FileService } from './services/file.service';
// @ts-ignore
import pj from '../package.json';
export var version = pj.version;
export var fetchBackendVersion = function (baseUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var ver;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(baseUrl + "/public/release")
                    .then(function (data) { return data.json(); })
                    .catch(function (err) {
                    console.warn(err.response && err.response.message);
                    return { version: 'unknown' };
                })];
            case 1:
                ver = (_a.sent()).version;
                return [2 /*return*/, ver];
        }
    });
}); };
export var INIT_AUTH_PROVIDER_TOKEN = Symbol('INIT_AUTH_PROVIDER');
export var INIT_API_SERVICE_TOKEN = Symbol('INIT_API_SERVICE');
export var INIT_HISTORY_TOKEN = Symbol('INIT_HISTORY');
export var INIT_FILE_SERVICE_TOKEN = Symbol('INIT_FILE_SERVICE');
export var IS_ROOT_INSTANCE = Symbol('IS_ROOT_INSTANCE');
// parse url params
export var startUrlParams = qs.parse(location.search, { ignoreQueryPrefix: true });
// say hello
export var sayHello = function (baseUrl) {
    if (baseUrl === void 0) { baseUrl = '/api/v1'; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _b = (_a = console).info;
                    _c = 'XBPM Backend Runtime v';
                    return [4 /*yield*/, fetchBackendVersion(baseUrl)];
                case 1:
                    _b.apply(_a, [_c + (_d.sent())]);
                    console.info("XBPM Front Runtime Core v" + coreVersion);
                    console.info("XBPM Front Runtime Web Core v" + version);
                    console.info("XBPM Front Runtime Web Bridge v" + bridgeVersion);
                    console.info("XBPM Front Runtime Web OAuth Provider v" + oauthVersion);
                    return [2 /*return*/];
            }
        });
    });
};
export var createAuthProvider = function (authConfig) {
    if (authConfig) {
        switch (authConfig.$kind) {
            case 'oauth':
                return new OAuthProvider(authConfig);
        }
    }
    return null;
};
export var createApiService = function (apiConfig, _a) {
    var httpRequestHandler = _a.httpRequestHandler, httpErrorHandler = _a.httpErrorHandler;
    return new XbpmApiService(apiConfig, { requestHandler: httpRequestHandler, errorHandler: httpErrorHandler });
};
export var createFileService = function () { return new FileService(); };
// is root web runtime instance
var _isRootInstance = function () {
    var isRootWindow = false;
    try {
        isRootWindow = window === window.parent || window.hasOwnProperty('Cypress');
    }
    catch (e) {
        console.warn('Access denied to root window');
    }
    return isRootWindow;
};
export var isRootInstance = function () { return injector.get(IS_ROOT_INSTANCE)(); };
// bind default handlers
injector.bind(INIT_AUTH_PROVIDER_TOKEN).toConstantValue(createAuthProvider);
injector.bind(INIT_API_SERVICE_TOKEN).toConstantValue(createApiService);
injector.bind(INIT_FILE_SERVICE_TOKEN).toConstantValue(createFileService);
injector.bind(INIT_HISTORY_TOKEN).toConstantValue(createBrowserHistory);
injector.bind(IS_ROOT_INSTANCE).toConstantValue(_isRootInstance);
export var initialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    var config, production, authConfig, apiConfig, navConfig, baseUrl, authProvider, authService, apiService, history, navService, logger, storage, store, context, fileService, isRoot, pubSub, navParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getConfig()];
            case 1:
                config = _a.sent();
                production = config.production, authConfig = config.authConfig, apiConfig = config.apiConfig, navConfig = config.navConfig, baseUrl = config.baseUrl;
                sayHello(apiConfig.baseURL);
                authProvider = injector.get(INIT_AUTH_PROVIDER_TOKEN)(authConfig);
                authService = new XbpmAuthService(authProvider);
                apiService = injector.get(INIT_API_SERVICE_TOKEN)(apiConfig, authService);
                history = injector.get(INIT_HISTORY_TOKEN)({ basename: baseUrl });
                navService = new XbpmWebNavService(history, navConfig);
                logger = new XbpmLogger();
                storage = new XbpmAsyncStorage(new StorageBrowser());
                store = createStore(production);
                context = XbpmContext.createContext(apiService, authService, navService, logger, storage, store);
                fileService = injector.get(INIT_FILE_SERVICE_TOKEN)();
                context.setProvider('fileService', fileService);
                isRoot = window === window.parent || window.hasOwnProperty('Cypress');
                // xbpm instance tools
                context.setProvider('isRootInstance', function () { return isRoot; });
                pubSub = new PubSub();
                if (!isRoot) {
                    context.setProvider('bridgeService', new XbpmBridgeClientService({ baseUrl: baseUrl }, pubSub, window.opener || window.parent, startUrlParams));
                }
                else {
                    context.setProvider('bridgeHostService', new XbpmBridgeHostService({ baseUrl: baseUrl }, pubSub));
                    context.setProvider('bridgeService', new XbpmBridgeClientService({ baseUrl: baseUrl }, pubSub, window, startUrlParams));
                }
                // xbpm context events
                if (isRoot) {
                    context.on(SCREENFLOW_END, function () { return navService.home(true); });
                    context.on(FORM_DESTROYED, function () { return context.getProvider('bridgeHostService').unloadAll(); });
                }
                else {
                    context.on(SCREENFLOW_END, function () { return context.getProvider('bridgeService').close(); });
                    context.on(NOT_AUTHORIZED, function () {
                        console.log('NOT_AUTHORIZED!');
                        return context.getProvider('bridgeService').reload({ targetId: 'root' });
                    });
                }
                // app initial nav
                if (eqUrlParts(location.pathname, baseUrl) || (baseUrl !== '/' && location.pathname === '/')) {
                    navParams = formatNavParams(startUrlParams);
                    if (navParams) {
                        navService.navigate(navParams, true);
                    }
                    else if (navConfig.home !== '/') {
                        navService.home(true);
                    }
                }
                return [2 /*return*/, context];
        }
    });
}); };
//# sourceMappingURL=context.js.map